import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Gtag from "@/plugins/gtag";
import { clickoutside } from "./directives/clickoutside";
import { i18n } from "./i18n";

Vue.config.productionTip = false;
Vue.directive("click-outside", clickoutside);
Vue.use(Gtag, {
  config: {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    conversion_id: process.env.VUE_APP_GOOGLE_CONVERSION_ID,
    enabled:
      typeof window !== "undefined"
        ? JSON.parse(localStorage.getItem("GDPR-accepted") || "false") || false
        : false
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
